import { gql } from '@apollo/client';

export const USER_UPDATE_FIELDS = gql`
  fragment UserUpdateFields on User {
    id
    firstName
    lastName
    email
    userType
    userRole
    displayColour
    settings
    createdAt
    deletedAt
  }
`; 